import React from 'react'
//import './App.css';
import './Projects.css';

function Projects() {
  return (
    <div className="projetcs-div" >
    
        <h2>
            Our subsidiaries
        </h2>
        <div className="App-link">
        
        <h3>
            SuloDecor
        </h3>
        
        
        <h4>
            Projects under SuloDecor
        </h4>
        <li></li>
        <li></li>
        </div>
        
        <div className="App-link">
        <h3>
            SuloTech
        </h3>
        
        <h4>
            Projects under SuloTech
        </h4>
        <li>
            <a href='https://moteev.store'>
                Moteev Online Retail
            </a>
        </li>
        <li>
        <a href='https://sleek-sound.web.app'>
                Sleek Sounds
        </a>
        </li>

        </div>
        
        <div className="App-link">
        <h3>
            Rose` Delights
        </h3>
        
        <h4>
            Projects under Rose`Delights
        </h4>
        <li></li>
        <li></li>
        </div>

        <div>

        </div>
       

       

    </div>
  )
}

export default Projects
